export const virtualCareListStyle = (mobileScreen: boolean) => ({
  boxSizing: 'border-box',
  padding: mobileScreen ? '16px 16px 24px 16px' : '32px 0 48px 0',
  zIndex: '0',
  maxWidth: '1200px',
  width: '100%',
  '& > *:first-child': {
    paddingTop: '0px',
  },
});

export const virtualCareListViewContainerStyle = (mobileScreen: boolean) => ({
  maxWidth: '1440px',
  marginLeft: mobileScreen ? '0px' : 'auto',
  marginRight: mobileScreen ? '0px' : 'auto',
  padding: mobileScreen ? '0px' : '0px 0px 16px',
});

export const headerContainerStyle = (mobileScreen: boolean) => ({
  alignSelf: 'stretch',
  paddingTop: '16px',
  paddingBottom: mobileScreen ? '16px' : '0px',
  height: '68px',
  position: 'sticky',
  top: '40px',
  zIndex: '3',
  backgroundColor: '#FFFFFF',
});

export const headerStyle = (mobileScreen: boolean) => ({
  width: '100%',
  maxWidth: '1200px',
  padding: mobileScreen ? '16px' : '0px 0px 16px 0px',
  borderBottom: '1px solid #CBCCCD',
  height: '52px',
});
